<template>
	<div>
		<b-button :disabled="project.locked" block type="button" variant="primary" @click="createSeed">Randomize</b-button>
		<b-button block type="button" variant="danger" :href="downloadUrl" target="_blank">Download</b-button>
		<b-button v-if="!project.locked" block type="button" variant="danger" @click="lockProject">Lock</b-button>
		<hr class="bg-primary"/>
		<b-list-group>
			<b-list-group-item v-for="prize in prizes" :key="prize.id" class="pl-0 pr-0">
				<h4>
					{{ prize.description }}
					<sup>
						<b-icon :id="`prize-${prize.id}`" :variant="getImportance( prize.importance )" icon="info-circle-fill"></b-icon>
					</sup>
					<b-badge class="float-right" pill variant="primary">{{ prize.quantity }}</b-badge>
					<b-tooltip :target="`prize-${prize.id}`" placement="bottomright" title="Importance">
						{{ prize.importance | capitalize }} Level
					</b-tooltip>
				</h4>
				<b-list-group>
					<b-list-group-item v-for="s in seed.entries.filter( f => f.prize.id === prize.id )" :key="s.id" class="pr-0">
						<h5>{{ s.project_product.description }} -
							<small class="text-muted">{{ s.project_product.supplier.name }}</small>
							<b-badge class="float-right" variant="secondary">{{ s.quantity }}</b-badge>
						</h5>
					</b-list-group-item>
				</b-list-group>
			</b-list-group-item>
		</b-list-group>
	</div>
</template>

<script>
import { PROJECT_LOCK, PROJECT_PRIZES_FETCH } from '../../store/actions/project'

export default {
	name: 'ProjectReport',

	computed: {
		project: function () { return this.$store.state.project.project },
		prizes: function () { return this.$store.state.project.prizes },
		downloadUrl: function () { return `${process.env.VUE_APP_API_URL}/seed/${this.seed.id}/download`; }
	},

	data () {
		return {
			seed: {
				entries: []
			}
		}
	},

	methods: {
		createSeed () {
			this.axios.post(`/projects/${this.project.id}/seed`)
				.then(response => {
					this.seed = response.data
				})
		},

		async lockProject () {
			this.$bvModal.msgBoxConfirm('Are you sure you want to lock this project?')
				.then(answer => {
					if (answer) {
						this.$store.dispatch(PROJECT_LOCK, this.project)
					}
				})

		},

		getImportance (importance) {
			switch (importance) {
				case 'low':
					return 'info'
				case 'medium':
					return 'warning'
				case 'high':
					return 'danger'
				default:
					return 'default'
			}
		},

		fetchData () {
			this.axios.get(`/projects/${this.project.id}/seed`)
				.then(response => {
					this.seed = response.data
				})
			this.$store.dispatch(PROJECT_PRIZES_FETCH, this.project.id)
		}
	},

	mounted () {
		if (this.project.id > 0) this.fetchData()
	},

	watch: {
		project: function () { this.fetchData() }
	}
}
</script>
